export const UserAvatarRepository = Symbol.for('UserAvatarRepository');
